abstract class BaseObject {
  protected attributes: string[] = [];

  public constructor() {
  }

  protected loadData(data = {}) {
    this.attributes.forEach((attribute: string) => {
      if (data[attribute] !== undefined) this[attribute] = data[attribute];
    });
  }
}

export class BookList extends BaseObject {
  protected attributes: string[] = ['books', 'page', 'total', 'pages'];

  public books: Array<Book> = [];
  public total: number = 0;
  public page: number = 1;
  public pages: number = 1;

  public constructor(data = {}) {
    super();
    this.loadData(data);
  }
}

export class Book extends BaseObject {
  protected attributes: string[] = ['id', 'name', 'alias', 'cover', 'description', 'chapters_count', 'author', 'bookmark', 'bookmarked', 'chapters', 'categories'];

  public id: number;
  public name: string;
  public alias: string;
  public cover: string;
  public description: string;
  public chapters_count: number;
  public author: Object;
  public bookmark: any;
  public bookmarked: boolean;
  public categories: Array<any>;
  public chapters: Array<any>;

  public constructor(data = {}) {
    super();
    this.loadData(data);
  }
}



// WEBPACK FOOTER //
// ./src/models/book.ts